import { ROUTES } from 'constants/routes';

/** Public marketing pages for platform features (guest-accessible, no auth). */
export const PLATFORM_FEATURE_ROUTES: Record<string, string> = {
  'ai-tutor': ROUTES.MARKETING_ASK_GURU,
  community: ROUTES.MARKETING_SANGHA,
};

/** In-page anchor for learning paths section on home. */
export const LEARNING_PATHS_SECTION_ID = 'learning-paths';
